import React from 'react'
import styles from "../header.module.less";

const Body = ({ className, children, ...rest }) =>
  <div className={`${styles.body} ${className} kiosk-color--brand-contrast-color`} {...rest}>{children}</div>

Body.defaultProps = {
  className: ''
}
export default Body
